import numeral from 'numeral';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import React, { PureComponent } from 'react';
import breakpoints from 'rp-mq-breakpoints';
import { profileUrl } from '../../helpers/urlBuilder';

const { venueid, salesdatestart } = document.getElementById('root').dataset;

export default class StatisticsLots extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        entities: PropTypes.arrayOf(PropTypes.shape({
            lot_no: PropTypes.number.isRequired,
            horse_style_name: PropTypes.string,
            horse_first_colour_code: PropTypes.string,
            horse_sex: PropTypes.string,
            horse_age: PropTypes.number,
            sire_style_name: PropTypes.string,
            dam_style_name: PropTypes.string,
            sire_of_dam_style_name: PropTypes.string,
            price: PropTypes.number,
        })).isRequired,
        colSpanGetter: PropTypes.func.isRequired,
    };
    static defaultProps = {
        className: '',
    };
    state = {
        colSpan: this.props.colSpanGetter(breakpoints.current().code)
    };
    componentDidMount() {
        window.addEventListener('rpBreakpointsSwitch', this.handleBreakpointsSwitch);
    }
    componentWillUnmount() {
        window.removeEventListener('rpBreakpointsSwitch', this.handleBreakpointsSwitch);
    }
    handleBreakpointsSwitch = (e) => {
        this.setState({
            colSpan: this.props.colSpanGetter(e.detail.breakpoint.code)
        });
    };
    renderHorseProfileLink(uid, name, bold = false) {
        return (
            <a
                href={profileUrl('horse', uid, name)}
                className="js-popupLink ui-link ui-link_table"
            >
                {bold ? <b>{name}</b> : name}
            </a>
        );
    }
    getLotNoHref(lot, letter) {
        return `/bloodstock/sales/catalogues/
            ${venueid}/${salesdatestart}?lot=${lot}&letter=
            ${encodeURIComponent(letter !== null ? letter : ' ')}`.replace(/\s+/g, '');
    }
    render() {
        return (
            <tr
                className={classnames('table__StatisticsLots', this.props.className)}
            >
                <td
                    className={classnames(
                        'table__StatisticsLotsCell',
                        this.props.cellClassName,
                    )}
                    colSpan={this.state.colSpan}
                >
                    <div
                        className={classnames(
                            'table__StatisticsLotsList',
                            this.props.listClassName
                        )}
                    >
                        {this.props.entities.map(item => (
                            <div
                                key={item.lot_no}
                                className="table__StatisticsLotsItem"
                            >
                                <span className="table__StatisticsLotsTerm">
                                    <a
                                        href={this.getLotNoHref(item.lot_no, item.lot_letter)}
                                        target="_blank"
                                        className="ui-link ui-link_table"
                                    >
                                        {item.lot_no}{item.lot_letter}
                                    </a>
                                </span>
                                {item.horse_uid && (
                                    <span className="table__StatisticsLotsTerm">
                                        {this.renderHorseProfileLink(
                                            item.horse_uid,
                                            item.horse_style_name,
                                        )}
                                    </span>
                                )}
                                {item.horse_first_colour_code && (
                                    <span className="table__StatisticsLotsTerm">
                                        {item.horse_first_colour_code}
                                    </span>
                                )}
                                {item.horse_sex && (
                                    <span className="table__StatisticsLotsTerm">
                                        {item.horse_sex}
                                    </span>
                                )}
                                {item.horse_age && (
                                    <span className="table__StatisticsLotsTerm">
                                        {item.horse_age}-y-o
                                    </span>
                                )}
                                {(item.sire_uid || item.dam_uid) && (
                                    <span className="table__StatisticsLotsTerm">
                                        {this.renderHorseProfileLink(
                                            item.sire_uid,
                                            item.sire_style_name,
                                        )}
                                        {item.sire_uid && item.dam_uid && ' — '}
                                        {this.renderHorseProfileLink(
                                            item.dam_uid,
                                            item.dam_style_name,
                                        )}
                                    </span>
                                )}
                                {item.sire_of_dam_uid && (
                                    <span className="table__StatisticsLotsTerm">
                                        {this.renderHorseProfileLink(
                                            item.sire_of_dam_uid,
                                            item.sire_of_dam_style_name,
                                        )}
                                    </span>
                                )}
                                <span className="table__StatisticsLotsTerm">
                                    {numeral(item.price).format('0,0')}
                                </span>
                            </div>
                        ))}
                    </div>
                </td>
            </tr>
        );
    }
}




// WEBPACK FOOTER //
// ./src/js/components/DataTable/StatisticsLots.js